// hooks/usePresence.js
import { useEffect } from "react";
import { ref, onDisconnect, set, serverTimestamp } from "firebase/database";
import { rtdb } from "../firebase";
export function usePresence(user) {
  useEffect(() => {
    if (!user?.uid) return;
    const statusRef = ref(rtdb, `status/${user.uid}`);
    set(statusRef, {
      state: "online",
      last_changed: serverTimestamp(),
    });
    onDisconnect(statusRef).set({
      state: "offline",
      last_changed: serverTimestamp(),
    });
  }, [user?.uid]);
}
